import type { Explorer } from '../types'

type CreateNoApiExplorerParameters = {
  name: string
  baseUrl: string
}

/**
 * createNoApiExplorer で生成した Explorer を保持する set。
 */
const noApiExplorers = new WeakSet<Explorer>()

/**
 * API を利用できない chain 向けの Explorer を生成する。各 API 関数は呼び出すと例外を投げる。
 * @param params.name Explorer 名
 * @param params.baseUrl Explorer の URL
 * @returns API を持たない Explorer
 */
export const createNoApiExplorer = ({
  name,
  baseUrl,
}: CreateNoApiExplorerParameters): Explorer => {
  const explorer: Explorer = {
    name,
    baseUrl,
    getAddressInternalTransactions: () => {
      throw new Error('Function not implemented.')
    },
    getAddressTransactionIndexes: () => {
      throw new Error('Function not implemented.')
    },
    getAddressTokenTransferIndexes: () => {
      throw new Error('Function not implemented.')
    },
    getBlockNumberOfTimestamp: () => {
      throw new Error('Function not implemented.')
    },
    getContract: () => {
      throw new Error('Function not implemented.')
    },
    getContractCreations: () => {
      throw new Error('Function not implemented.')
    },
    getEventLogs: () => {
      throw new Error('Function not implemented.')
    },
    getInternalTransactionOfTransaction: () => {
      throw new Error('Function not implemented.')
    },
  }
  noApiExplorers.add(explorer)
  return explorer
}

/**
 * Explorer が createNoApiExplorer で生成された API を持たない Explorer かどうかを判定する。
 * @param params.explorer 判定対象の Explorer
 * @returns API を持たない Explorer の場合 true
 */
export const isNoApiExplorer = ({
  explorer,
}: {
  explorer: Explorer
}): boolean => noApiExplorers.has(explorer)
